import {Model} from '@vuex-orm/core'

export class Configuration extends Model {
  static entity = 'Configuration'

  static fields () {
    return {
      id: this.number(null),
      textDeposant: this.string('')
    }
  }

  static fetchConfiguration ($depotVente) {
    return this.api().get('/deposant/' + $depotVente + '/texte');
  }
}
